import Router from "next/router";
import React from 'react';
import { useSelector } from "react-redux";
import { useRegionCountryCode } from "../hooks/region";
import { urlForCountryCode } from "../lib/region";
import { RootState } from "../store/reducers/reducers";

export function withRedirectForNoCountryCode<P extends object>(WrappedComponent: React.ComponentType<P>) {
  return ({ ...props }) => {
    const regionInfo = useRegionCountryCode()
    const profileFetched = useSelector((state: RootState) => state.user.profileFetched)
    const tfaPassed = useSelector((state: RootState) => state.user.tfaPassed)
    const signedIn = useSelector((state: RootState) => state.user.signedIn)
    const preferredRegion = useSelector((state: RootState) => state.region.preferredRegion)

    React.useEffect(() => {
      if (regionInfo.isLoading || !profileFetched) {
        return
      }

      const { search, pathname } = window.location
      let query = ''
      if (search) {
        query = search.substring(1)
      }

      // Check if pathname already contains a country code
      const pathParts = pathname.split('/')
      if (pathParts.length > 1 && pathParts[1].length === 2) {
        // Path already has a country code, no need to redirect
        return
      }

      let url
      if (signedIn && tfaPassed && preferredRegion) {
        url = urlForCountryCode(preferredRegion, pathname, query)
      } else {
        url = urlForCountryCode(regionInfo.countryCode, pathname, query)
      }

      // Only redirect if the URL is different from current location
      if (url !== window.location.pathname + (query ? `?${query}` : '')) {
        Router.replace(url);
      }
    }, [profileFetched, tfaPassed, signedIn, regionInfo.countryCode, regionInfo.isLoading, preferredRegion])
    return <WrappedComponent {...props as P} />
  }
}